import axios from 'axios';
import { CareHome, SearchRequest } from '../types';

const API_BASE_URL = import.meta.env.PROD ? '' : 'http://localhost:3001';

class ApiService {
    private axiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            timeout: 10000,
        });
    }

    async searchCareHomes(searchRequest: SearchRequest): Promise<{
        success: boolean;
        data: CareHome[];
        count: number;
        searchCenter: { latitude: number; longitude: number };
    }> {
        try {
            const response = await this.axiosInstance.post('/api/search', searchRequest);
            return response.data;
        } catch (error) {
            console.error('Search API error:', error);
            throw new Error('Failed to search care homes');
        }
    }

    async healthCheck(): Promise<{ status: string; timestamp: string; service: string }> {
        try {
            const response = await this.axiosInstance.get('/api/health');
            return response.data;
        } catch (error) {
            console.error('Health check API error:', error);
            throw new Error('Health check failed');
        }
    }
}

export default new ApiService(); 